export default function StickScrambleIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="50" width="60" height="12" rx="2" fill="#5B5370" />
      <path d="M8 50 l4 -6 4 6 4 -6 4 6" fill="#D9DEE6" />
      <circle cx="18" cy="14" r="5.5" fill="#2F8BFF" />
      <path d="M18 20 L17 34 M17 34 L11 46 M17 34 L22 46 M18 24 L28 22 M18 25 L10 31" stroke="#2F8BFF" strokeWidth="4" />
      <circle cx="31" cy="21" r="3" fill="#FFE36B" />
      <g transform="rotate(-20 46 18)">
        <circle cx="46" cy="14" r="5.5" fill="#FF8A1F" />
        <path d="M46 20 L46 34 M46 34 L40 46 M46 34 L52 46 M46 24 L38 30 M46 24 L54 20" stroke="#FF8A1F" strokeWidth="4" />
      </g>
      <path d="M34 8 l3 4 M38 6 l1 5 M30 9 l3 3" stroke="#FFFFFF" strokeWidth="2.5" />
    </svg>
  );
}
